import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const LoginModal = ({ onClose }) => {
  const [isLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const { login, register } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // 清除之前的错误
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isLogin) {
        // 登录逻辑
        await login(formData.email, formData.password);
        onClose();
      } else {
        // 注册逻辑
        if (formData.password !== formData.confirmPassword) {
          setError('两次输入的密码不一致');
          return;
        }
        await register(formData.username, formData.email, formData.password);
        onClose();
      }
    } catch (err) {
      // 统一错误提示
      if (isLogin) {
        setError('邮箱或密码错误');
      } else {
        if (err.message.includes('email') || err.message.toLowerCase().includes('duplicate')) {
          setError('该邮箱已被注册');
        } else if (err.message.includes('password')) {
          setError('密码格式不正确，请使用8-20位字符');
        } else {
          setError('注册失败，请稍后重试');
        }
      }
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay login-modal-overlay" onClick={handleOverlayClick}>
      <div className="auth-form login-modal-background" onClick={e => e.stopPropagation()}>
        <h2>{isLogin ? '登录' : '注册'}</h2>
        <button className="login-modal-close" onClick={onClose}>&times;</button>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        {!isLogin && (
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="请输入用户名"
              required={!isLogin}
            />
          </div>
        )}

        <div className="form-group">
          <label htmlFor="email">邮箱</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="请输入邮箱"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">密码</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder={isLogin ? "请输入密码" : "请设置密码"}
            required
          />
        </div>

        {!isLogin && (
          <div className="form-group">
            <label htmlFor="confirmPassword">确认密码</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="请再次输入密码"
              required={!isLogin}
            />
          </div>
        )}

        <button type="submit" className="submit-button">
          {isLogin ? '登录' : '注册'}
        </button>
      </form>

    
      {/* <div className="auth-switch">
        {isLogin ? (
          <p>还没有账号？ <button onClick={() => setIsLogin(false)}>立即注册</button></p>
        ) : (
          <p>已有账号？ <button onClick={() => setIsLogin(true)}>立即登录</button></p>
        )}
      </div> */}
    </div>
    </div>
  );
};

export default LoginModal;